import { useMutation } from '@tanstack/react-query';
import { postSubscribe } from '@pulsex/services';
export default function useSubscribe(domain) {
    var _a, _b, _c, _d, _e, _f;
    function generateUserId() {
        return `user-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    }
    const mutation = useMutation({
        mutationFn: (email) => postSubscribe(domain, email, generateUserId()),
        retry: 0,
    });
    let status;
    if (!mutation.isPending && mutation.data) {
        switch (mutation.data.code) {
            case 200:
                status = 'success';
                break;
            case 400:
                if (((_a = mutation.data) === null || _a === void 0 ? void 0 : _a.error) && ((_c = (_b = mutation.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.includes('already subscribed'))) {
                    status = 'alreadySubscribed';
                }
                else {
                    status = 'error';
                }
                break;
            case 429:
                if (((_d = mutation.data) === null || _d === void 0 ? void 0 : _d.error) && ((_f = (_e = mutation.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.includes('Please retry after'))) {
                    status = 'emailAlreadySent';
                }
                else {
                    status = 'error';
                }
                break;
            default:
                status = 'error';
        }
    }
    return {
        subscribe: mutation.mutate,
        reset: mutation.reset,
        isLoading: mutation.isPending,
        status,
    };
}
